module.exports = __webpack_public_path__ + "img/blank_meeting.aba44a6d.svg";